export const pick = (
	obj: Record<string, unknown>,
	predicate: (key: string, value: unknown) => boolean,
): Record<string, unknown> => {
	const newObj: Record<string, unknown> = {};

	Object.keys(obj).forEach((key) => {
		if (predicate(key, obj[key])) {
			newObj[key] = obj[key];
		}
	});

	return newObj;
};
